import { Tooltip } from 'antd';
import styled from 'styled-components';
import {
  maxTablet, primaryFont, primaryHeadingColor, wMedium,
} from 'Utils/utilsStyle';

type Props = {
  color: string,
  title: string,
  showTooltip?: boolean,
};

const defaultProps = {
  showTooltip: false,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  .title {
    font-size: 13px;
    line-height: 14px;
    color: ${primaryHeadingColor};
    letter-spacing: -0.4px;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    margin-bottom: 0px;
    margin-left: 8px;
    width: calc(100% - 26px);
    word-break: break-all;
    @media all and (max-width: ${maxTablet}) {
      font-size: 12px;
    }
  }
`;

const Bullet = styled.div<{ color: string }>`
 background-color: ${(props) => props.color};
 height: 12px;
 width: 12px;
 min-width: 12px;
 border-radius: 50%;
`;

const TriggerBulletWidget = function TriggerBulletWidget(props: Props) {
  const { title, color, showTooltip } = props;
  return (
    <Wrapper className="trigger-bullet">
      <Bullet className="bullet" color={color} />
      {showTooltip ? (
        <Tooltip
          placement="top"
          getPopupContainer={(e: HTMLElement) => e}
          className="triggers-bullet-tooltip"
          color="#fff"
          title={title}
          arrow={false}
        >
          <h6 className="title text-truncate-one-line">{title}</h6>
        </Tooltip>
      ) : (
        <h6 className="title">{title}</h6>
      )}
    </Wrapper>
  );
};
TriggerBulletWidget.defaultProps = defaultProps;
export default TriggerBulletWidget;
